import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import useLocales from 'hooks/useLocales';

const parseAiCredits = (value: number | string | undefined): number => {
  if (value === undefined || value === null) {
    return 0;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const useAICreditAvailability = (requiredCredits: number) => {
  const { t } = useLocales();
  const aiCredits = useSelector(
    (state: RootState) =>
      state.company.companies?.subscription?.current_limit?.ai_credits
  );

  const availableCredits = useMemo(
    () => parseAiCredits(aiCredits),
    [aiCredits]
  );

  const hasEnoughCredits = availableCredits >= requiredCredits;
  const outOfCreditsTooltip = t(
    'You have run out of AI credits for this billing period.'
  );

  return {
    availableCredits,
    hasEnoughCredits,
    isCreditLimited: !hasEnoughCredits,
    outOfCreditsTooltip
  };
};
